import React, { useState, useEffect, useContext } from "react";
import { useDispatch } from "react-redux";
import axios from "axios";
import moment from "moment";
import { useHistory } from "react-router-dom";
import { Card, CardBody, Layout, Menu, Row, Col, Button, Space, message, Empty, Spin, Tag } from "antd";
import Icon, { LeftOutlined, RightOutlined, TrophyOutlined, DollarOutlined, MoneyCollectOutlined, DislikeOutlined, DislikeFilled, NodeIndexOutlined, RiseOutlined, DashboardOutlined, ThunderboltOutlined, HeartOutlined, CompassOutlined, StarOutlined, ClockCircleOutlined, FireOutlined } from "@ant-design/icons";

import { setBreadcrumb } from "redux/actions/app.action";
import generalService from "services/general.service";
import generalHelper from "helper/general.helper";
import ActivityService from "services/activity.service";

import Header from "components/shared/Header";
import Filter from "components/overview/Filter";
import DataTable from "components/overview/DataTable";
import emptyImg from "assets/img/empty.svg";

import { SocketContext } from "contexts/SocketContext";
import { AppContext } from "contexts/AppContext";

import {
  CANCEL_REQUEST,
  DATE_TIME_FORMAT,
  FILE_TYPE,
  STATS_TYPE,
  WS_URL,
  TOKEN_NAME,
  VIEW_TYPE,
  SPORT_TYPE,
  SPORT_ICONS
} from "constants/index";

import AuthorizedFunction from "config/AuthorizedFunction";

const Leaderboard = () => {
  // const socket = useContext(SocketContext);
  // const [wsMessage, setWSMessage] = useState("");
  const appContext = useContext(AppContext);
  const [leaderboard, setLeaderboard] = useState([]);
  const [pastLeaderboard, setPastLeaderboard] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [dateRange, setDateRange] = useState(null);

  const dispatch = useDispatch();

  const history = useHistory();
  const goto = (path) => {
    redirect(path);
  };
  const redirect = (path) => {
    history.push({
      pathname: path.pathname,
      search: path.search,
    });
  };

  // useEffect(() => {
  //   socket.on("update-activity-list", (notes) => {
  //     if (notes) {
  //       setTableData(notes);
  //     } else {
  //       setTableData([]);
  //     }
  //   });
  //   dispatch(setBreadcrumb(["All listing"]));
  //   onSearch({ start: dateRange.startDate.format(DATE_TIME_FORMAT.DBDATE), end: dateRange.endDate.format(DATE_TIME_FORMAT.DBDATE) });
  // }, [socket, dateRange]);

  useEffect(() => {
    // dispatch(setBreadcrumb(["All listing"]));
    appContext.setSelectedAthlete(null);
    onSearch({ 
      start: appContext.dateRange.startDate.format(DATE_TIME_FORMAT.DBDATE), 
      end: appContext.dateRange.endDate.format(DATE_TIME_FORMAT.DBDATE), 
      view: appContext.pageView, 
      sport: appContext.sportView, 
      ranked: false, 
      all: false, 
      active: true });
  }, [dateRange, appContext.dateRange, appContext.sportView, appContext.selectedAthlete]);

  const onSearch = (params) => {
    setIsLoading(true);
    const CancelToken = axios.CancelToken;
    const source = CancelToken.source();

    ActivityService.getLeaderboard(params, source).then(
      (request) => {
        setLeaderboard(request.leaderboard);
        setPastLeaderboard(request.pastLeaderboard);
        setTimeout(() => {
          setIsLoading(false);
        }, 200);
      },
      (error) => {
        if (error && error.message !== CANCEL_REQUEST) {
          message.error("API got error, please contact us.", 5);
        }
        console.log(error);
        setIsLoading(false);
        return Promise.reject();
      }
    );
  };

  const Activity = (data) => {
    return (
      <>
        <Space
          key={data.id}
          direction="vertical"
          size={16}
          style={{ width: "100%" }}
        >
          <Card
            bordered={true}
            className={"leaderboard-item"}
            onClick={() => {
              appContext.setSelectedAthlete({...data, dateRange: appContext.dateRange});
              goto({ pathname: `/athletes/${data.athlete_id}`, search: `?start=${appContext.dateRange.startDate.format(DATE_TIME_FORMAT.DBDATE)}&end=${appContext.dateRange.endDate.format(DATE_TIME_FORMAT.DBDATE)}&view=${appContext.pageView}&sport=${appContext.sportView}` });
            }}
          >
            <div className="user-panel">
              <div className={data.ranking === 1 ? `leaderboard rank-1` : data.ranking === 2 ? `leaderboard rank-2` : data.ranking === 3 ? `leaderboard rank-3` : ""}></div>
              <div className={appContext.sportView !== SPORT_TYPE.All && data.kom ? `rank rank-1` : ""}></div>
              <img className="avatar" src={data.avatar} />
              <span className="athlete-name">
                <a href={`https://www.strava.com/athletes/${data.athlete_id}`} onClick={(e) => e.stopPropagation()}>
                  {data.name}
                </a>
              </span>
              <div className="stats-info">
                <span className="additional-info"><TrophyOutlined /> {data.point}</span>
                {/* <span className="additional-info"><MoneyCollectOutlined /> {data.redeemed}</span> */}
                <span className="additional-info"><DislikeOutlined /> {data.total_flagged}</span>
                <span className="additional-info"><img src={SPORT_ICONS[appContext.sportView]} /> {data.total_tracklog}</span>
              </div>
            </div>
            { appContext.sportView !== SPORT_TYPE.All &&
              <div className="item-content">
                <div className="stats-header">Distance: <span className="stats-value">{generalHelper.formatDistance(data.total_distance, 1, true)}</span><Tag bordered={false} color="processing" className="additional-stats"><NodeIndexOutlined /><span className="stats-value">{generalHelper.formatDistance(data.max_distance, 1, true)}</span></Tag></div>
                <div className="stats-header">Gain: <span className="stats-value">{generalHelper.formatDisplayNumber(data.total_elevation_gain, 0, STATS_TYPE.Elevation, false, true, false)}</span>{generalHelper.calculateIncline(data.total_elevation_gain, data.total_distance, true, true, true)}</div>
                <div className="stats-header">Time: <span className="stats-value">{generalHelper.formatDisplayTime(data.total_moving_time)} ({generalHelper.formatDisplayTime(data.total_elapsed_time)})</span></div>
                <div className="stats-panel">
                  {generalHelper.formatDisplayNumber(data.avg_heartrate_over_time, 0, STATS_TYPE.Heartrate, true, true, true)}
                  {generalHelper.calculatePace([{metters: data.total_distance, seconds: data.total_moving_time}], appContext.sportView, true, true, true)}
                  {generalHelper.formatDisplayNumber(data.avg_watts_over_time, 0, STATS_TYPE.Power, true, true, false)}
                </div>
                { data.total_calories || data.avg_temp ?
                <div className="stats-panel">
                  {generalHelper.formatDisplayNumber(data.total_calories, 0, STATS_TYPE.Calories, true, true, true)}
                  {generalHelper.formatDisplayNumber(data.avg_temp_over_time, 0, STATS_TYPE.Temp, true, true, false)}
                  {generalHelper.formatCadence(data.avg_cadence_over_time, 0, appContext.sportView, true, true, false)}
                </div>
                : ""}
              </div>
            }
            { appContext.sportView === SPORT_TYPE.All &&
                <div className="item-content">
                <div className="stats-header">Time: <span className="stats-value">{generalHelper.formatDisplayTime(data.total_moving_time)} ({generalHelper.formatDisplayTime(data.total_elapsed_time)})</span></div>
                <div className="stats-panel">
                  {generalHelper.formatDisplayNumber(data.avg_heartrate_over_time, 0, STATS_TYPE.Heartrate, true, true, true)}
                  {generalHelper.formatDisplayNumber(data.total_calories, 0, STATS_TYPE.Calories, true, true, true)}
                  {generalHelper.formatDisplayNumber(data.avg_temp_over_time, 0, STATS_TYPE.Temp, true, true, false)}
                </div>
              </div>
            }
          </Card>
        </Space>
      </>
    );
  };

  const PastLeaderboard = (list) => {
    return (
      <>
        <Space
          direction="vertical"
          size={16}
          style={{ width: "100%" }}
        >
          <Card
            bordered={true}
            className={"leaderboard-panel"}
          >
            { list.map((data) => {
              return (
                <div className="user-panel" key={data.athlete_id}>
                  <div className={data.ranking === 1 ? `achievement rank-1` : data.ranking === 2 ? `achievement rank-2` : data.ranking === 3 ? `achievement rank-3` : ""}></div>
                  <img className="avatar" src={data.avatar} />
                  <span className="athlete-name">
                    <a href={`https://www.strava.com/athletes/${data.athlete_id}`}>{data.name}</a>
                  </span>
                  { appContext.sportView !== SPORT_TYPE.All &&
                    <div className="stats-info">
                      <span className="additional-info"><NodeIndexOutlined /> {generalHelper.formatDistance(data.total_distance, 1, true)}</span>
                      <span className="additional-info"><RiseOutlined /> {generalHelper.formatDisplayNumber(data.total_elevation_gain, 0, STATS_TYPE.Elevation, false, true, false)}</span>
                      <span className="additional-info"><img src={SPORT_ICONS[appContext.sportView]} /> {data.total_tracklog}</span>
                    </div>
                  }
                  { appContext.sportView === SPORT_TYPE.All &&
                    <div className="stats-info">
                      <span className="additional-info"><ClockCircleOutlined /> {generalHelper.formatDisplayTime(data.total_moving_time)}</span>
                      <span className="additional-info"><FireOutlined /> {generalHelper.formatDisplayNumber(data.total_calories, 0, STATS_TYPE.Calories, false, true, false, false)}</span>
                      <span className="additional-info"><img src={SPORT_ICONS[appContext.sportView]} /> {data.total_tracklog}</span>
                    </div>
                  }
                </div>
              )
            })}
          </Card>
        </Space>
      </>
    );
  };

  return (
    <>
      <Space direction="vertical" size={16} style={{ width: "100%" }}>
        <Row gutter={[32, 24]}>
          <Col flex="auto" sm={24}>
          {!isLoading ? (
            <>
              {pastLeaderboard && pastLeaderboard.length > 0 && PastLeaderboard(pastLeaderboard)}
              {leaderboard && leaderboard.length > 0 ? leaderboard.map((s) => Activity(s)) : (
                <Empty image={emptyImg} imageStyle={{height: 60, marginTop: 60}} description={<span>No data</span>}></Empty>
              )}
            </>
          ) : (
            <Empty image={emptyImg} imageStyle={{height: 60}} description={<span>Loading..</span>}>
              <Spin />
            </Empty>
          )}
          </Col>
        </Row>
      </Space>
    </>
  );
};

export default Leaderboard;
